<template>
  <div v-if="program">
    <sticky v-if="!source" class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title" v-if="program">{{program.name | cap}} - Création d'un lot</span>
    </sticky>
    <div :class="{'columns is-gapless is-margin-left-on-btn-actions is-padding-top' : !source}">
      <div :class="{'column is-10 is-9-widescreen is-8-fullhd' : !source}">
        <div class="has-bg-white is-border">
          <lot-form v-if="program" @submit="submit" :source="lot" :program="program" :loading="loading"></lot-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round :isLoading="loading" v-else></spinner-round>
</template>


<script>
  import LotForm from '@/components/lot/LotForm'
  import { Error } from '@/mixins'

  export default {
    name: 'LotCreate',
    mixins: [Error],
    data () {
      return {
        loading: false,
        lot: null,
        program: null
      }
    },
    props: {
      source: Object
    },
    components: {
      LotForm
    },
    methods: {
      getLot (id) {
        this.loading = true
        this.$api.lotService.getOne(id).then(res => {
          this.lot = res.data
          this.getProgram(res.data.program)
        }).catch(() => {
          this.loading = false
        })
      },
      submit (lot) {
        this.loading = true
        console.log(lot)
        this.$api.lotService.post(lot).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le lot a bien été créé'
          })
          this.$router.goBack(this.$route)
        }).catch((err) => {
          this.handleError(err, 'Erreur lors de l\'ajout du lot.')
          this.loading = false
        })
      },
      getProgram (programPk) {
        this.$api.programService.getOne(programPk).then(r => {
          this.program = r.data
          this.loading = false
        })
      }
    },
    created () {
      if (this.$route.query.duplicateLot) {
        this.getLot(this.$route.query.duplicateLot)
      } else if (this.source) {
        this.program = Object.assign({}, this.source)
      } else if (this.$route.query.program) {
        this.getProgram(this.$route.query.program)
      } else {
        this.$router.push({name: 'Forbidden'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotCreate.vue